import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import UploadImage from "../../UploadImage";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  leftGrid: {
    maxHeight: 100,
  },
  last: {
    margin: 0,
  },
  topBar: {
    padding: 0,
  },
  pagination: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  "&::placeholder": {
    color: "grey",
  },
}));

export default function ReportForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();
  const [type, setType] = React.useState("1");
  const [originalData, setOriginalData] = React.useState("");
  const typeList = { "Annual Report": "1", "Financial Report": "2" };

  const { control, handleSubmit, setValue, getValues } = useForm();

  const formatRowToData = (row) => {
    return {
      years: row.years,
      typeId: row.type,
      pdfPath: row.pdfPath,
      updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    }
  }

  useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getReportById(id)
        .then((response) => {
          console.log(response.data);
          setOriginalData(response.data);
          setValue("years", response.data.years);
          setValue("type", typeList[response.data.type]);
          setValue("pdfPath", response.data.pdfPath);
          setType(typeList[response.data.type]);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateReport = async (data) => {
    try {
      console.log(formatRowToData(data));
      const result = await apiHelper.hkiff.updateReportById(
        id, formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
    } catch (err) {
      console.log(err);
    }
  };

  const createReport = async (data) => {
    try {
      const result = await apiHelper.hkiff.postReport(
        formatRowToData(data)
      );
      if (result.data.id) {
        toast.dark("Report created.");
        history.push("/hkiff/report");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    console.log(data);
    const sendReport = () => {
      if (id) {
        updateReport(data);
      } else {
        createReport(data);
      }
    };
    sendReport();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="years"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Year"
                    variant="outlined"
                    {...field}
                    fullWidth
                  />
                );
              }}
            />


            <UploadImage
              name="pdfPath"
              data={originalData}
              control={control}
              Controller={Controller}
              setValue={setValue}
              getValues={getValues}
              disabled={disabled}
              uploadLabel="Upload PDF"
              changeLabel="Change PDF"
              uploadFolder="REPORTS"
            />

            <Controller
              defaultValue={type}
              name="type"
              control={control}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => (
                <ToggleButtonGroup
                  {...rest}
                  value={type}
                  onChange={(event, newFormats) => {
                    if (newFormats) {
                      setValue(`type`, newFormats);
                      setType(newFormats);
                    }
                  }}
                  exclusive
                  aria-label="status"
                  style={{ width: "350px", marginBottom: "40px", background: "#FFFFFF" }}
                >
                  <ToggleButton
                    value="1"
                    aria-label="online"
                    disabled={disabled}
                  >
                    Annual Report
                    </ToggleButton>
                  <ToggleButton
                    value="2"
                    aria-label="offline"
                    disabled={disabled}
                  >
                    Financial Report
                    </ToggleButton>
                </ToggleButtonGroup>
              )}
            />

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
